import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const checkUser = () => {
      const user = localStorage.getItem("user_id");
      if (!user) {
        navigate("/login");
      } else {
        setTimeout(() => setIsLoading(false), 500);
      }
    };
    checkUser();
  }, [navigate]);

  const toggleSidebar = () => setSidebarOpen((v) => !v);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) setSidebarOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflow = sidebarOpen ? "hidden" : "auto";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebarOpen]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-white text-gray-900 flex flex-col items-center justify-center">
        <div className="w-16 h-16 relative">
          <div className="w-16 h-16 rounded-full border-t-4 border-b-4 border-primary animate-spin" />
          <div
            className="w-16 h-16 rounded-full border-r-4 border-l-4 border-transparent border-r-[#01CC54] animate-spin absolute top-0 left-0"
            style={{ animationDirection: "reverse", animationDuration: "1s" }}
          />
        </div>
        <h2 className="mt-4 text-xl font-semibold text-gray-900">
          Loading BluTec PING...
        </h2>
        <p className="text-gray-600 text-sm mt-2">
          Please wait while your dashboard is prepared
        </p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-white text-gray-900">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Main content wrapper with proper margins for fixed header */}
      <div className="flex-1 lg:ml-64 flex flex-col">
        {/* Fixed Header */}
        <Header toggleSidebar={toggleSidebar} />

        {/* Main content with top padding to account for fixed header */}
        <main className="flex-1 overflow-x-hidden pt-12 md:pt-14">
          <div>{children}</div>
        </main>

        {/* Optional footer */}
        {/* <footer className="border-t border-gray-200 p-4 text-center text-gray-500 text-xs mt-auto">
          <p>© 2025 BluTec PING. All rights reserved.</p>
        </footer> */}
      </div>
    </div>
  );
};

export default Layout;
